import * as React from "react";
const SvgPalette = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#palette_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 12a8.965 8.965 0 1 0-17.93 0A8.965 8.965 0 0 0 12 20.965c1.085 0 1.965-.88 1.965-1.965v-.5c0-.431-.002-.747.035-1.026A4.035 4.035 0 0 1 17.474 14c.279-.037.595-.035 1.026-.035h.5c1.085 0 1.965-.88 1.965-1.965M7 11.965a.035.035 0 0 0-.035.035c0 .02.016.035.035.035q.015 0 .024-.01L7.035 12l-.01-.024A.04.04 0 0 0 7 11.965m9-4a.035.035 0 0 0-.035.035.034.034 0 0 0 .06.024l.01-.024-.01-.024A.03.03 0 0 0 16 7.965m-6-1A.035.035 0 0 0 9.965 7a.034.034 0 0 0 .06.024l.01-.024-.01-.024A.03.03 0 0 0 10 6.965M9.035 12a2.035 2.035 0 1 1-4.07 0 2.035 2.035 0 0 1 4.07 0m14 0A4.035 4.035 0 0 1 19 16.035h-.5c-.497 0-.646.002-.757.017a1.965 1.965 0 0 0-1.691 1.691c-.015.11-.017.26-.017.757v.5A4.035 4.035 0 0 1 12 23.035C5.906 23.035.965 18.095.965 12S5.905.965 12 .965 23.035 5.905 23.035 12m-5-4a2.035 2.035 0 1 1-4.07 0 2.035 2.035 0 0 1 4.07 0m-6-1a2.035 2.035 0 1 1-4.07 0 2.035 2.035 0 0 1 4.07 0"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "palette_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgPalette;
//# sourceMappingURL=Palette.js.map